import PropTypes from "prop-types";
import React from "react";

const SearchFilters = (props) => {
  const { title, tabs, templatesSelected = [], handleSelectedTemplates } = props;

  return (
    <fieldset className="fr-fieldset" id="templates-list" aria-labelledby="templates-list-filters">
      <legend className="fr-fieldset__legend" id="templates-list-legend">
        {title}
      </legend>
      {tabs.length > 0 &&
        tabs.map((tab) => (
          <div className="fr-fieldset__element" key={tab.title}>
            <div className="fr-checkbox-group fr-checkbox-group--sm">
              <input
                name={tab.title}
                id={tab.title}
                type="checkbox"
                aria-describedby={`${tab.title}-template`}
                checked={templatesSelected.some((t) => tab.templates.includes(t))}
                data-fr-js-checkbox-input="true"
                disabled={tab.pages === 0}
                onChange={() => handleSelectedTemplates(tab.templates || [])}
              />
              <label className="fr-label" htmlFor={tab.title}>
                {`${tab.title} (${tab.pages})`}
              </label>
            </div>
          </div>
        ))}
    </fieldset>
  );
};

SearchFilters.propTypes = {
  title: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      templates: PropTypes.arrayOf(PropTypes.string).isRequired,
      pages: PropTypes.number,
    }).isRequired,
  ),
  templatesSelected: PropTypes.arrayOf(PropTypes.string),
  handleSelectedTemplates: PropTypes.func.isRequired,
};

export default SearchFilters;
